import { Box, Grid, Skeleton, Stack } from '@mui/material';
import { widgetCardSx } from './shared';

/** Скелетон одного виджета — заголовок, подпись покрытия и тело. */
const WidgetSkeleton = ({ bodyHeight = 220 }: { bodyHeight?: number }) => (
  <Box sx={widgetCardSx}>
    <Skeleton variant="text" width={90} height={16} />
    <Skeleton variant="text" width="55%" height={28} />
    <Skeleton variant="text" width={120} height={16} sx={{ mb: 2 }} />
    <Skeleton variant="rounded" width="100%" height={bodyHeight} />
  </Box>
);

/** Скелетоны на каждый виджет дашборда — повторяют сетку реального экрана. */
const VacancyStatsSkeleton = () => (
  <Stack spacing={3} sx={{ pb: 4 }}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <WidgetSkeleton bodyHeight={240} />
      </Grid>
      <Grid item xs={12} md={6}>
        <WidgetSkeleton bodyHeight={240} />
      </Grid>
    </Grid>
    <WidgetSkeleton bodyHeight={320} />
    <WidgetSkeleton bodyHeight={320} />
    <WidgetSkeleton bodyHeight={180} />
  </Stack>
);

export default VacancyStatsSkeleton;
